"use strict";

(function () {
  'use strict';

  angular.module('lr.core.routes', ['ngRoute']).factory('loadIntercept', ['$q', '$rootScope', function ($q, $rootScope) {
    var numLoadings = 0;
    return {
      request: function request(config) {
        numLoadings++; // Show loader

        $rootScope.$broadcast('loader_show');
        return config || $q.when(config);
      },
      response: function response(_response) {
        if (--numLoadings === 0) {
          // Hide loader
          $rootScope.$broadcast('loader_hide');
        }

        return _response || $q.when(_response);
      },
      responseError: function responseError(response) {
        if (! --numLoadings) {
          // Hide loader
          $rootScope.$broadcast('loader_hide');
        }

        return $q.reject(response);
      }
    };
  }]).config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('loadIntercept');
  }]).run(['$rootScope', '$location', '$window', 'authEvents', 'User', function ($rootScope, $location, $window, authEvents, User) {
    $rootScope.$on('$routeChangeStart', function () {
      if (User.getToken() == null) {
        $rootScope.$broadcast(authEvents.login);
      }

      $rootScope.$broadcast('toggle-lrSideNav');
    });
  }]).config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
    $routeProvider.when('/', {
      templateUrl: 'app/dashboard/dashboard.view.html',
      controller: 'DashboardCtrl',
      controllerAs: 'Dash',
      title: 'Dashboard'
    }).when('/property-state-manager', {
      templateUrl: 'app/properties/properties.view.html',
      controller: 'PropertiesCtrl',
      controllerAs: 'Properties',
      title: 'Property Manager'
    }).when('/settings', {
      templateUrl: 'app/settings/settings.view.html',
      controller: 'SettingsCtrl',
      controllerAs: 'Settings',
      title: 'Account Settings'
    }).when('/property-state-manager/map', {
      templateUrl: 'app/properties/properties.map.view.html',
      controller: 'PropertiesCtrl',
      controllerAs: 'Properties',
      title: 'Property Manager Map'
    }).when('/login', {
      template: '<button class="btn btn-primary" ng-click="login()">Login</button>',
      controller: ['$scope', '$location', function ($scope, $location) {
        $scope.login = function () {
          $location.path('/');
        };
      }],
      title: 'Login'
    }).otherwise('/');
    $locationProvider.html5Mode(true);
  }]);
})();